import { pdf } from "@react-pdf/renderer";
import type { PurchaseOrderSummary } from "@/services/suprimentos";
import { PurchaseOrderPdfDocument } from "./PurchaseOrderPdfDocument";
import { buildPurchaseOrderPdfModel } from "./purchaseOrderPdfModel";

async function renderPdfBlob(
  summary: PurchaseOrderSummary,
  options: { geradoPor: string; billId?: string; creditorFallback?: string },
): Promise<{ blob: Blob; filenameBase: string }> {
  const model = buildPurchaseOrderPdfModel(summary, options);
  const blob = await pdf(<PurchaseOrderPdfDocument data={model} />).toBlob();
  return { blob, filenameBase: model.filenameBase };
}

function openPdfBlob(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
}

function downloadPdfBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.endsWith(".pdf") ? filename : `${filename}.pdf`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function generatePurchaseOrderPdf(
  summary: PurchaseOrderSummary,
  options: { geradoPor: string; billId?: string; creditorFallback?: string },
): Promise<void> {
  const { blob, filenameBase } = await renderPdfBlob(summary, options);
  openPdfBlob(blob);
  downloadPdfBlob(blob, filenameBase);
}
